module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc) {
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm);
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<div class=\"modal__container\" id=\"error-modal\">\n    <div class=\"modal__wrapper\">\n        <div class=\"modal_content\">\n            <div class=\"modal_body\">\n                <h1> <%= getLocale('uh_oh_exclamation') %> </h1>\n                <p> <%= getLocale('something_went_wrong_please_try_again') %> </p>\n            </div>\n\n            <div class=\"modal_footer\">\n                <div class=\"modal_cta\">\n                    <button class=\"button\" id=\"cta1\">\n                        <div class=\"button__text\"><%= getLocale('go_back') %></div>\n                    </button>\n                </div>\n            </div>\n        </div>\n\n        \n    </div>\n</div>"
  , __filename = "node_modules/.pnpm/git@github.com+cbsi-cbscom+web-package-coreui@35250b477861e1b400ec4b954c3360abe68bde4c_fetch-_uiwgr7wycj22ilxojixpl5pevy/node_modules/cbs-core-ui/src/js/templates/modals/__errorModal.tpl";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  var __locals = (locals || {}),
data = __locals.data,
  selected = __locals.selected;
  with (locals || {}) {
    ; __append("<div class=\"modal__container\" id=\"error-modal\">\n    <div class=\"modal__wrapper\">\n        <div class=\"modal_content\">\n            <div class=\"modal_body\">\n                <h1> ")
    ; __line = 5
    ; __append(escapeFn( getLocale('uh_oh_exclamation') ))
    ; __append(" </h1>\n                <p> ")
    ; __line = 6
    ; __append(escapeFn( getLocale('something_went_wrong_please_try_again') ))
    ; __append(" </p>\n            </div>\n\n            <div class=\"modal_footer\">\n                <div class=\"modal_cta\">\n                    <button class=\"button\" id=\"cta1\">\n                        <div class=\"button__text\">")
    ; __line = 12
    ; __append(escapeFn( getLocale('go_back') ))
    ; __append("</div>\n                    </button>\n                </div>\n            </div>\n        </div>\n\n        \n    </div>\n</div>")
    ; __line = 20
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL="node_modules/.pnpm/git@github.com+cbsi-cbscom+web-package-coreui@35250b477861e1b400ec4b954c3360abe68bde4c_fetch-_uiwgr7wycj22ilxojixpl5pevy/node_modules/cbs-core-ui/src/js/templates/modals/__errorModal.tpl"

}